import { SkuDetail } from '../../models/SkuDetail';
import { UseCase } from '../UseCase';
import { SkuRepository } from '../../repositories/SkuRepository';

export class GetSkuDetailUseCase implements UseCase<GetSkuDetailRequestDto, SkuDetail>{
    constructor(
        private skuRepo: SkuRepository
    ) { }
    execute(t: GetSkuDetailRequestDto): Promise<SkuDetail> {
        return this.skuRepo.getSkuDetail(t.sku);
    }
}

export class GetSkuDetailRequestDto {
    constructor(
        public sku: string
    ) { }
}